import styled from 'styled-components'
import { Checkbox as NatDsCheckbox } from '@naturacosmeticos/natds-web'

export const Checkbox = styled(NatDsCheckbox)`
  svg {
    width: 2.4rem;
    height: 2.4rem;
  }
`
